import { apiClient } from "../apiClient";
export const XEP_LOAI_HOC_TAP_ENDPOINT = "xep-loai-hoc-tap";
export const xepLoaiHocTapApi = {
    SelectAll: () => apiClient.get(XEP_LOAI_HOC_TAP_ENDPOINT),
    Insert: (payload: any) => apiClient.post(XEP_LOAI_HOC_TAP_ENDPOINT, payload),
    Update: (id: number, payload: any) => apiClient.put(`${XEP_LOAI_HOC_TAP_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${XEP_LOAI_HOC_TAP_ENDPOINT}/${id}`)
};